import React, { useState, useEffect, useMemo } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Link, useParams } from "react-router-dom";
import ModelAddEvent from "./ModelAddEvent";
import ModelViewEvent from "./ModalViewEvent";
import { api } from "../../../utils/Api";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import DeleteAlert from "../../../components/Alert/DeleteAlert";
import Pagination from "../../../components/Pagination/Pagination";

const table_header = [
  {
    name: "ID",
    width: "5",
  },
  {
    name: "Name",
    width: "30",
  },
  {
    name: "Created By",
    width: "30",
  },
  {
    name: "Created At",
    width: "30",
  },
  {
    name: "",
    width: "5",
  },
];

const delete_table_header = [
  {
    name: "Name",
    width: "30",
  },
  {
    name: "Deleted User",
    width: "30",
  },
  {
    name: "Deleted At",
    width: "30",
  },
  {
    name: "",
    width: "10",
  },
];

let PageSizeOption = [10, 20, 30, 40, 50];

export default function AdminEvent(props: any) {
  const [event_data, SetEventData] = useState([]);
  const [deleted_event_data, SetDeletedEventData] = useState([]);
  const [openAddModal, SetopenAddModal] = useState(false);
  const [viewModal, SetViewModal] = useState({
    is_open: false,
    record: {},
    type: "view",
    record_index: "",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [selected_data, SetSelectedData] = useState({
    value: "",
    i: "",
    type: "",
  });
  const [delete_modal, SetDeleteModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  const [CurrentPage, SetCurrentPage] = useState(1);
  const [DeleteCurrentPage, SetDeleteCurrentPage] = useState(1);
  const [search_data, SetSearchData] = useState("");
  const [delete_search_data, SetDeleteSearchData] = useState("");
  const [PageSize, SetPageSize] = useState(10);
  const [DeletePageSize, SetDeletePageSize] = useState(10);
  const [active_table_data, SetActiveTableData] = useState([]);
  const [delete_table_data, SetDeleteTableData] = useState([]);

  function sample_fun(anchor, open, event) {
    console.log("sample_fun anchor :", anchor);
    console.log("sample_fun open :", open);
    console.log("sample_fun event :", event);
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      console.log("return");
      return;
    }
    console.log("toggle else");

    setState({ ...state, [anchor]: open });
  }

  const list = (anchor) => (
    <div className="mt-3">
      <div>
        <div className="d-flex justify-content-center">
          <div className="w-25 px-4">
            <hr className="h-3" />
          </div>
        </div>
        {selected_data.type == "active" ? (
          <ul>
            <li
              className="p-2 pb-3 cursor align-center"
              onClick={(event) => {
                SetViewModal({
                  is_open: true,
                  record: selected_data.value,
                  type: "view",
                  record_index: selected_data.i,
                });
                sample_fun(anchor, false, event);
                console.log("selected Data: ", selected_data);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/eye.svg")}
                className="me-2 action_menu_img cursor"
              />
              View
            </li>
            <li
              className="p-2 pb-3 cursor align-center"
              onClick={(event) => {
                SetViewModal({
                  is_open: true,
                  record: selected_data.value,
                  type: "edit",
                  record_index: selected_data.i,
                });
                sample_fun(anchor, false, event);
                console.log("selected Data: ", selected_data);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/edit-3.svg")}
                className="me-2 action_menu_img cursor"
              />
              Edit
            </li>
            <li
              className="p-2 pb-3 cursor align-center"
              onClick={(event) => {
                // delete_event(selected_data.value, selected_data.i);
                SetDeleteModal((prevValue) => {
                  prevValue.is_open = true;
                  prevValue.title = "Event";
                  prevValue.record = selected_data.value;
                  prevValue.index = selected_data.i;
                  return { ...prevValue };
                });
                sample_fun(anchor, false, event);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/trash-2.svg")}
                className="me-2 action_menu_img cursor"
              />
              Delete
            </li>
          </ul>
        ) : (
          <ul>
            <li
              className="p-2 pb-3 cursor align-center"
              onClick={(event) => {
                SetViewModal({
                  is_open: true,
                  record: selected_data.value,
                  type: "view",
                  record_index: selected_data.i,
                });
                sample_fun(anchor, false, event);
                console.log("selected Data: ", selected_data);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/eye.svg")}
                className="me-2 action_menu_img cursor"
              />
              View
            </li>
          </ul>
        )}
      </div>
    </div>
  );

  useEffect(() => {
    console.log("AdminEvent On mount :", props);
    get_events();
  }, []);

  async function get_events() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
    };
    let data = await api("/brand/events", pass_data);
    console.log("events response :", data.response);
    if (data.response.hasOwnProperty("events")) {
      SetEventData(data.response.events);
      const firstPageIndex = (CurrentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      SetActiveTableData(
        data.response.events.slice(firstPageIndex, lastPageIndex)
      );
    }
    if (data.response.hasOwnProperty("deleted_events")) {
      SetDeletedEventData(data.response.deleted_events);
      const DeletefirstPageIndex = (DeleteCurrentPage - 1) * DeletePageSize;
      const DeletelastPageIndex = DeletefirstPageIndex + DeletePageSize;
      SetDeleteTableData(
        data.response.deleted_events.slice(
          DeletefirstPageIndex,
          DeletelastPageIndex
        )
      );
    }
  }

  function AddModalOnClose(data: any) {
    console.log("AddModalOnClose data :", data);
    SetopenAddModal(false);
    if (data.action == "save") {
      SetEventData((prevValue) => {
        if (prevValue == undefined) {
          prevValue = [];
          prevValue.push(data.value);
        } else {
          prevValue.push(data.value);
        }
        return [...prevValue];
      });
      get_events();
    }
  }

  async function delete_event(record: any, index: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: {
        event_id: record.id,
      },
    };
    let data = await api("/brand/delete_event", pass_data);
    console.log("delete_event response :", data);
    if (data.status_code == 200) {
      // let old_events = event_data;
      // old_events.splice(index, 1);
      // SetEventData([...old_events]);
      get_events();
    }
  }

  function ViewModalOnClose(data: any) {
    console.log("ViewModalOnClose data :", data);
    SetViewModal({
      is_open: false,
      record: {},
      type: "view",
      record_index: "",
    });
    if (data.action == "edit") {
      SetEventData((prevValue) => {
        prevValue[data.index] = data.value;
        return [...prevValue];
      });
      get_events();
    }
  }

  function search_on_change(e: any) {
    console.log("search_on_change : ", e.target.value);

    if (e.target.value == "") {
      const firstPageIndex = (CurrentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      SetActiveTableData(event_data.slice(firstPageIndex, lastPageIndex));
    } else {
      const filter_value = event_data.filter((obj) =>
        JSON.stringify(obj).toLowerCase().includes(e.target.value.toLowerCase())
      );
      console.log("filter_value : ", filter_value);
      SetActiveTableData(filter_value);
    }
  }

  function delete_search_on_change(e: any) {
    console.log("delete_search_on_change : ", e.target.value);

    if (e.target.value == "") {
      const firstPageIndex = (DeleteCurrentPage - 1) * DeletePageSize;
      const lastPageIndex = firstPageIndex + DeletePageSize;
      SetDeleteTableData(
        deleted_event_data.slice(firstPageIndex, lastPageIndex)
      );
    } else {
      const filter_value = deleted_event_data.filter((obj) =>
        JSON.stringify(obj).toLowerCase().includes(e.target.value.toLowerCase())
      );
      console.log("filter_value : ", filter_value);
      SetDeleteTableData(filter_value);
    }
  }

  return (
    <div>
      <div className="bg-fff pt-3 px-4 ">
        <div className="row align-items-center pb-2">
          <div className="col-md-5 col-6">
            <h5 className="  mb-0 text-dark fw-bolder">Events</h5>
            {/* <p className="v-small mb-0">20+ events organized</p> */}
          </div>
          <div className="col-md-7 col-6 justify-content-end d-flex align-items-center">
            <div
              className="btn-light-outline d-flex align-items-center text-dark cursor py-1 px-2 "
              onClick={() => {
                console.log("SetopenAddModal :", event_data);
                SetopenAddModal(true);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/plus1.svg")}
                className=" pe-2"
              />{" "}
              Add
            </div>
          </div>
        </div>
        {/* <nav className="pt-1 sticky-tabs">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="active-event-tab"
              data-bs-toggle="tab"
              data-bs-target="#active-event"
              type="button"
              role="tab"
              aria-controls="active-event"
              aria-selected="true"
            >
              Active Events
            </button>
            <button
              className="nav-link "
              id="deleted-event-tab"
              data-bs-toggle="tab"
              data-bs-target="#deleted-event"
              type="button"
              role="tab"
              aria-controls="deleted-event"
              aria-selected="false"
            >
              Deleted Events
            </button>
          </div>
        </nav> */}
      </div>
      <div className="container tabs-after-container">
        <div className="tab-content" id="nav-tabContent">
          {/* Active Event */}
          <div
            className="tab-pane fade show active"
            id="active-event"
            role="tabpanel"
            aria-labelledby="active-event-tab"
          >
            <div className="card px-4 py-3">
              <div className="row pb-3">
                <div className="col-md-8 pb-2">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 pe-2">Show</p>
                    <select
                      className="form-select flex-basis-20"
                      aria-label="Default select example"
                      value={PageSize}
                      onChange={(e) => {
                        SetPageSize(e.target.value);
                        const firstPageIndex =
                          (CurrentPage - 1) * e.target.value;
                        const lastPageIndex = firstPageIndex + e.target.value;
                        SetActiveTableData(
                          event_data.slice(firstPageIndex, lastPageIndex)
                        );
                      }}
                    >
                      {PageSizeOption.map((ele, index) => (
                        <option value={ele} key={index}>
                          {ele}
                        </option>
                      ))}
                    </select>
                    <p className="mb-0 ps-2">records per page</p>
                  </div>
                </div>
                <div className="col-md-4 pb-2 text-end">
                  <input
                    type="text"
                    className="form-control"
                    id="staticEmail"
                    placeholder="Search in records..."
                    value={search_data}
                    onChange={(e) => {
                      SetSearchData(e.target.value);
                      search_on_change(e);
                    }}
                  />
                </div>
              </div>
              {active_table_data.length > 0 ? (
                <>
                  <div className="d-lg-block d-md-none">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          {table_header.map((head, t_index) => (
                            <th key={t_index}>{head.name}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {active_table_data.map((data, e_index) => (
                          <tr key={e_index}>
                            <td>{data.id}</td>
                            <td className="mb-1">{data.name}</td>
                            <td>{data.created_user}</td>
                            <td>{data.created_at}</td>
                            <td className="dropdown cursor">
                              <div
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/more-horizontal.svg")}
                                  className="action_img cursor"
                                />
                              </div>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <div
                                    className="cursor dropdown-item"
                                    onClick={() => {
                                      console.log("view");
                                      SetViewModal({
                                        is_open: true,
                                        record: data,
                                        type: "view",
                                        record_index: e_index,
                                      });
                                    }}
                                    style={{ marginRight: "5px" }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/eye.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; View
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className="cursor dropdown-item"
                                    onClick={() => {
                                      SetViewModal({
                                        is_open: true,
                                        record: data,
                                        type: "edit",
                                        record_index: e_index,
                                      });
                                    }}
                                    style={{ marginRight: "5px" }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/edit-3.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; Edit
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className="cursor dropdown-item"
                                    onClick={() => {
                                      // delete_event(data, e_index);
                                      SetDeleteModal((prevValue) => {
                                        prevValue.is_open = true;
                                        prevValue.title = "Event";
                                        prevValue.record = data;
                                        prevValue.index = e_index;
                                        return { ...prevValue };
                                      });
                                    }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/trash-2.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; Delete
                                  </div>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-lg-none">
                    {active_table_data.map((data, e_index) => (
                      <div
                        key={e_index}
                        className="row mb-2 border-bottom"
                        onClick={(event) => {
                          sample_fun("bottom", true, event);
                          SetSelectedData({
                            value: data,
                            i: e_index,
                            type: "active",
                          });
                        }}
                      >
                        <div className="col-10">
                          <h6 className="mb-1">{data.name}</h6>
                        </div>

                        <div className="col-6 mt-1">
                          <p>{data.created_user}</p>
                        </div>
                        <div className="col-6 mt-1">
                          <p className="v-small">{data.created_at}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="row align-items-center">
                    <div className="col-md-8">
                      {search_data == "" ? (
                        <Pagination
                          className="pagination-bar"
                          currentPage={CurrentPage}
                          totalCount={event_data.length}
                          pageSize={PageSize}
                          onPageChange={(page) => {
                            console.log("Page :", page);
                            const firstPageIndex = (page - 1) * PageSize;
                            const lastPageIndex = firstPageIndex + PageSize;
                            SetCurrentPage(page);
                            SetActiveTableData(
                              event_data.slice(firstPageIndex, lastPageIndex)
                            );
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <div className="text-center">
                  <img
                    src={require("../../../assets/img/svg/no_data_2.svg")}
                    className="w-30 pb-2"
                  />
                  <p className="v-small mb-0">No Data, Please Add Event</p>
                </div>
              )}
            </div>
          </div>
          {/* Deleted Event */}
          {/* <div
            className="tab-pane fade"
            id="deleted-event"
            role="tabpanel"
            aria-labelledby="deleted-event-tab"
          >
            <div className="card px-4 py-3">
              <div className="row pb-3">
                <div className="col-md-8 pb-2">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 pe-2">Show</p>
                    <select
                      className="form-select flex-basis-20"
                      aria-label="Default select example"
                      value={DeletePageSize}
                      onChange={(e) => {
                        console.log("Show on change :", e);
                        SetDeletePageSize(e.target.value);
                        const firstPageIndex =
                          (DeleteCurrentPage - 1) * e.target.value;
                        const lastPageIndex = firstPageIndex + e.target.value;
                        SetDeleteTableData(
                          deleted_event_data.slice(
                            firstPageIndex,
                            lastPageIndex
                          )
                        );
                      }}
                    >
                      {PageSizeOption.map((ele, index) => (
                        <option value={ele} key={index}>
                          {ele}
                        </option>
                      ))}
                    </select>
                    <p className="mb-0 ps-2">records per page</p>
                  </div>
                </div>
                <div className="col-md-4 pb-2 text-end">
                  <input
                    type="text"
                    className="form-control"
                    id="staticEmail"
                    placeholder="Search in records..."
                    value={delete_search_data}
                    onChange={(e) => {
                      SetDeleteSearchData(e.target.value);
                      delete_search_on_change(e);
                    }}
                  />
                </div>
              </div>

              <div className="d-lg-block d-md-none">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      {delete_table_header.map((data, dh_index) => (
                        <th key={dh_index}>{data.name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {delete_table_data.map((data, e_index) => (
                      <tr key={e_index}>
                        <td className="mb-1">{data.name}</td>
                        <td>{data.deleted_user}</td>
                        <td>{data.deleted_at}</td>
                        <td className="dropdown cursor">
                          <div
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={require("../../../assets/icon/svg/more-horizontal.svg")}
                              className="action_img cursor"
                            />
                          </div>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton2"
                          >
                            <li>
                              <div
                                className="cursor dropdown-item"
                                onClick={() => {
                                  console.log("view");
                                  SetViewModal({
                                    is_open: true,
                                    record: data,
                                    type: "view",
                                    record_index: e_index,
                                  });
                                }}
                                style={{ marginRight: "5px" }}
                              >
                                <img
                                  src={require("../../../assets/icon/svg/eye.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; View
                              </div>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="d-lg-none">
                {delete_table_data.map((data, e_index) => (
                  <div
                    key={e_index}
                    className="row mb-2 border-bottom"
                    onClick={(event) => {
                      sample_fun("bottom", true, event);
                      SetSelectedData({
                        value: data,
                        i: e_index,
                        type: "delete",
                      });
                    }}
                  >
                    <div className="col-10">
                      <h6 className="mb-1">{data.name}</h6>
                    </div>

                    <div className="col-6 mt-1">
                      <p>{data.deleted_user}</p>
                    </div>
                    <div className="col-6 mt-1">
                      <p className="v-small">{data.deleted_at}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row align-items-center">
                <div className="col-md-8">
                  {delete_search_data == "" ? (
                    <Pagination
                      className="pagination-bar"
                      currentPage={DeleteCurrentPage}
                      totalCount={deleted_event_data.length}
                      pageSize={DeletePageSize}
                      onPageChange={(page) => {
                        console.log("Page :", page);
                        const firstPageIndex = (page - 1) * DeletePageSize;
                        const lastPageIndex = firstPageIndex + DeletePageSize;
                        SetDeleteCurrentPage(page);
                        SetDeleteTableData(
                          deleted_event_data.slice(
                            firstPageIndex,
                            lastPageIndex
                          )
                        );
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <ModelAddEvent
        open={openAddModal}
        close={(data) => {
          AddModalOnClose(data);
        }}
      />
      <ModelViewEvent
        data={viewModal}
        close={(data) => {
          ViewModalOnClose(data);
        }}
      />

      <DeleteAlert
        open={delete_modal.is_open}
        title={delete_modal.title}
        record={delete_modal.record}
        index={delete_modal.index}
        close={(data) => {
          SetDeleteModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete event : ", data);
            delete_event(data.value, data.index);
            // delete_user(data.index, data.value);
          }
        }}
      />

      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            // onClose={toggleDrawer(anchor, false)}
            // onOpen={toggleDrawer(anchor, true)}
            onClose={(event) => {
              sample_fun(anchor, false, event);
            }}
            onOpen={(event) => {
              sample_fun(anchor, true, event);
            }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
